import ApplicationController from './application_controller';

export default class extends ApplicationController {
  connect() {
    const reloadFrame = this.element.closest('#reload-frame');
    reloadFrame?.setAttribute('src', '');
    reloadFrame?.setAttribute('src', reloadFrame?.dataset.src);
    this.element.remove();
  }
}